module.exports = __webpack_public_path__ + "static/media/account-light.b013da54.svg";